import {Component, Input, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup, Validators,} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from '../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {TramsInvoiceFilterResult} from '../../model/trams-invoice-filter-result';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Subscription} from 'rxjs';

@AutoUnsubscribe()
@Component({
    selector: 'trams-invoices-filter-modal',
    templateUrl: './trams-invoices-filter-modal.component.html',
    standalone: false
})
export class TramsInvoiceFilterModalComponent implements OnInit {
  @Input() config!: TramsInvoiceFilterResult;

  breakPoint$?:Subscription;
  isSmall: boolean = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<TramsInvoiceFilterModalComponent>,
    breakpointObserver: BreakpointObserver,
  ) {  
      this.breakPoint$ = breakpointObserver.observe([
        Breakpoints.Medium,
        Breakpoints.Small,
        Breakpoints.XSmall
      ]).subscribe(result => {
          this.isSmall = result.matches;
      });

  }

  form: FormGroup = new FormGroup({
    tramsInvoiceNo: new FormControl('',[Validators.pattern(/^[1-9]\d*$/), Validators.min(1)]),
    invoiceRecordLocator: new FormControl('', Validators.pattern(/^\S*$/)),
    issueStartDate: new FormControl(null),
    issueEndDate: new FormControl(null),
    createdStartDate: new FormControl(null),
    createdEndDate: new FormControl(null)
  });

  handleTramsInvoiceFiltersFormCloseEvent() {
    if (!this.dialogRef) {
      return;
    }
    this.dialogRef.close(null);
  }

  ngOnInit() {
    if (this.config) {
      const {tramsInvoiceNo, invoiceRecordLocator, issueStartDate, issueEndDate, createdStartDate, createdEndDate} = this.config;
      this.form.patchValue({
        tramsInvoiceNo: tramsInvoiceNo || null,
        invoiceRecordLocator: invoiceRecordLocator || '',
        issueStartDate: issueStartDate ? new Date(issueStartDate) : null,
        issueEndDate: issueEndDate ? new Date(issueEndDate) : null,
        createdStartDate: createdStartDate ? new Date(createdStartDate) : null,
        createdEndDate: createdEndDate ? new Date(createdEndDate) : null
      });
    }
  }

  applyTramsInvoiceFilters() {
    const formValues = this.form.value;
    this.config = {
      tramsInvoiceNo: formValues.tramsInvoiceNo ? Number(formValues.tramsInvoiceNo) : null,
      invoiceRecordLocator: formValues.invoiceRecordLocator?.trim() || null,
      issueStartDate: formValues.issueStartDate,
      issueEndDate: formValues.issueEndDate,
      createdStartDate: formValues.createdStartDate,
      createdEndDate: formValues.createdEndDate
    };
    
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    }
    else if (this.dialogRef) {
      this.dialogRef.close(this.config);
    }
  }

  public clearTramsInvoiceFilters(propertyName: string): void {
    if (propertyName === 'all') {
      this.config = {} as TramsInvoiceFilterResult;
      this.form.reset();
    }else{
      this.form.get(propertyName)?.setValue(null);
      
      const temp = { ...this.config };
      delete temp[propertyName as keyof TramsInvoiceFilterResult];
      this.config = temp;
      this.form.patchValue({ [propertyName]: null });
    }
  }
}
